import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface PatientProfileDetails {
  patientProfileInfo: {
    patientProfileId: number;
    name: string;
    dob: string;
    mmEnrollmentDate: string;
    emailId: string;
    userName: string;
    smsNotification: boolean;
    emailNotification: boolean;
    contactNumber: string;
    optoutNotification: boolean;
    preferredLanguage: string;
    recentDeliveryDueDate: string;
    actualDeliveryDate: string | null;
    duration: number;
    durationText: string;
  };
}

const initialPatientProfileDetails: PatientProfileDetails = {
  patientProfileInfo: {
    patientProfileId: 0,
    name: "",
    dob: "",
    mmEnrollmentDate: "",
    emailId: "",
    userName: "",
    smsNotification: false,
    emailNotification: false,
    contactNumber: "",
    optoutNotification: false,
    preferredLanguage: "",
    recentDeliveryDueDate: "",
    actualDeliveryDate: "",
    duration: 0,
    durationText: "",
  },
};

const patientProfileDetailsSlice = createSlice({
  name: "patientProfileDetails",
  initialState: initialPatientProfileDetails,
  reducers: {
    setPatientProfileId(state, action: PayloadAction<number>) {
      state.patientProfileInfo.patientProfileId = action.payload;
    },
    setPatientProfileDetails(
      state,
      action: PayloadAction<PatientProfileDetails>
    ) {
      state.patientProfileInfo = action.payload.patientProfileInfo;
    },
  },
});

export const patientProfileDetailsActions = patientProfileDetailsSlice.actions;

export default patientProfileDetailsSlice.reducer;
